import { render, staticRenderFns } from "./CaseSample.vue?vue&type=template&id=a028f2fc&lang=pug"
import script from "./CaseSample.vue?vue&type=script&lang=js"
export * from "./CaseSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports